export default __webpack_public_path__ + "1d98e6d8192f226c1b014b0987cb294f.svg";